import React from 'react'
import PropTypes from 'prop-types'

// import styles from './ContactForm.module.scss'

const ContactForm = ({ showContactForm, name, contactFormStyles }) => (
    <>
        <button type="button" style={contactFormStyles} onClick={showContactForm}>{name}</button>
    </>
)

ContactForm.propTypes = {
    showContactForm: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    contactFormStyles: PropTypes.objectOf(PropTypes.any).isRequired,
}

export default ContactForm
